import styled from 'styled-components';
import theme from '../../../../theme';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: calc(100% - 40px);
    max-width: 600px;

    > span {
        font-size: 13px;
        font-weight: 400;
        color: ${theme.textDark};
        margin: 10px 0 20px 0;
    }

    ul {
        list-style-type: none;

        li + li {
            margin-top: 20px;
        }

        li {
            display: flex;

            input {
                appearance: none;
                border: 2px solid ${theme.primaryColor};
                border-radius: 50%;
                width: 24px;
                height: 24px;
                margin: 0;
                
                &::after {
                    content: "";
                    display: block;
                    border-radius: 50%;
                    width: 16px;
                    height: 16px;
                    margin: 2px;
                }
                
                &:checked::after {
                    background-color: ${theme.primaryColor};
                }
            }

            div {
                display: flex;
                flex-direction: column;
                width: fit-content;
                padding: 10px;
                border-radius: 8px;
                box-shadow: 0px 0px 15px 0px #00000033;
                margin: 0 10px;

                img {
                    width: 109px;
                }

                span {
                    width: 109px;
                    font-size: 11px;
                    font-weight: 400;
                    color: ${theme.textDark};
                }
            }
        }
    }
`;

export { Container };